import { IconButton, List, ListItem, ListItemText } from "@mui/material";

import { Documentation } from "../models/Documentation";
import Timeoff from "../models/Timeoff";

import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props {
  viewTimeoff: Timeoff | undefined;
  selectedFiles: Documentation[];
  onDelete: (files: Documentation[]) => void;
}

export default function TimeOffDocumentationList(props: Props) {
  return (
    <List dense>
      {props.selectedFiles.map((item: Documentation, index: number) => (
        <ListItem
          key={index}
          secondaryAction={
            <>
              {item.url && (
                <IconButton
                  edge="end"
                  aria-label="view"
                  onClick={() => {
                    window.open(item.url, "_blank");
                  }}
                >
                  <SearchIcon />
                </IconButton>
              )}
              {!props.viewTimeoff && (
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => {
                    let files = props.selectedFiles;
                    files.splice(index, 1);
                    props.onDelete(files);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </>
          }
        >
          <ListItemText primary={item?.name?.length > 60 ? item?.name?.substring(0, 60).concat("...") : item.name || item.url} />
        </ListItem>
      ))}
    </List>
  );
}
